import { useEffect, useState } from "react";
import PasswordInput from "../user/PasswordInput";
import { useMount, useToggle } from "react-use";
import { useMutation, useQueryClient } from "react-query";
import { updateUserPassword } from "../../api";

const MyInfoAccount = ({ data }) => {
  const queryClient = useQueryClient();
  const [on, toggle] = useToggle(false);
  const [password, setPassword] = useState({
    cur: "",
    new: "",
    cck: "",
    error: "",
    confirm: false,
  });
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState(null);

  const { mutate: updateMutation } = useMutation({
    mutationFn: updateUserPassword,
    onSettled: (result) => {
      if (result && result.result) {
        toggle();
      }
      setError(result.error);
      queryClient.invalidateQueries({ queryKey: ["user/update"] });
    },
  });

  const handleUpdate = () => {
    updateMutation({ id: data.user_id, ...password });
  };

  const handlePasswordChange = (e, bError) => {
    setError(null);
    const [target] = e.target.id.split("-");
    if (target === "cur") {
      setPassword({
        ...password,
        [target]: e.target.value,
        confirm: !!password.new && password.new === password.cck,
      });
    } else {
      if (
        password.new &&
        password.cck &&
        ((target === "new" && password.cck !== e.target.value) ||
          (target === "cck" && password.new !== e.target.value))
      ) {
        setPassword({
          ...password,
          [target]: e.target.value,
          error: "입력한 비밀번호가 일치하지 않습니다.",
        });
      } else {
        setPassword({
          ...password,
          [target]: e.target.value,
          error: bError,
        });
      }
    }
  };

  useMount(() => {
    setPassword({
      cur: "",
      new: "",
      cck: "",
      error: "",
      confirm: false,
    });
  });

  useEffect(() => {
    setPassword({
      cur: "",
      new: "",
      cck: "",
      error: "",
      confirm: false,
    });
    setError(null);
  }, [on]);

  useEffect(() => {
    if (
      password.cur &&
      password.new &&
      password.new === password.cck &&
      !error
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [password, error]);

  return (
    <div className="flex flex-col justify-center mt-2 border rounded-xl pb-2 px-4 gap-2">
      <div className="inline-flex items-center justify-between mt-1">
        <label className="label font-bold text-primary">계정 정보</label>
      </div>
      <div className="inline-flex items-center gap-2 h-8">
        <label className="text-sm font-bold w-16 text-end">이름</label>
        <span>{data.name}</span>
      </div>
      <div className="inline-flex items-center gap-2 h-8">
        <label className="text-sm font-bold w-16 text-end">아이디</label>
        <span>{data.userId}</span>
      </div>
      <div
        className={`inline-flex items-baseline justify-start gap-2 swap ${
          on && "swap-active"
        }`}
      >
        <label className="text-sm font-bold w-16 text-end">비밀번호</label>
        <button
          className={`btn btn-primary btn-outline btn-sm h-8 swap-off ${
            on && "hidden"
          }`}
          onClick={toggle}
        >
          변경
        </button>
        <div
          className={`flex flex-col justify-start w-full md:w-2/3 swap-on ${
            !on && "hidden"
          }`}
        >
          <div className="inline-flex items-center gap-2 text-sm flex-auto">
            <div className="form-control w-full mb-1">
              <input
                type="password"
                id="cur-password"
                placeholder="현재 비밀번호"
                className="input input-bordered text-sm h-10"
                onChange={handlePasswordChange}
                value={password.cur}
              />
            </div>
          </div>
          <div className="inline-flex items-center gap-2 text-sm">
            <PasswordInput
              {...{
                id: "new-password",
                placeholder: "새 비밀번호",
                className: "text-sm h-10",
                onChange: handlePasswordChange,
                value: password.new,
              }}
            />
          </div>
          <div className="inline-flex items-center gap-2 text-sm">
            <PasswordInput
              {...{
                id: "cck-password",
                placeholder: "새 비밀번호 확인",
                className: "text-sm h-10",
                onChange: handlePasswordChange,
                value: password.cck,
              }}
            />
          </div>
          {!password.confirm && (
            <span className="text-sm text-left text-red-500 mb-2">
              {password.error}
            </span>
          )}
          {!!error && (
            <span className="text-sm text-left text-red-500 mb-2">{error}</span>
          )}
          <div className="inline-flex items-center gap-2 text-sm">
            <button className="btn btn-sm flex-none" onClick={toggle}>
              취소
            </button>
            <button
              className="btn btn-primary btn-sm flex-auto"
              disabled={disabled}
              onClick={handleUpdate}
            >
              변경
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyInfoAccount;
